// libraries
import React from 'react';

// custom components
import ProviderDashboardLayout from '../ProviderDashboardLayout';

const Analytics = (): JSX.Element => <ProviderDashboardLayout>Analytics</ProviderDashboardLayout>;

export default Analytics;
